import React from 'react';
import cx from 'classnames';
import IconButton from '../../../../components/IconButton';
import {faEdit, faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import styles from '../../ContactForm.module.scss';
import {ContactForm} from '../../../../types/ContactForm';

interface FormHeaderProps {
    currentForm: ContactForm;
    toggleFormVisibility: (formId: string) => Promise<void>;
    onBackClick: () => void;
    onEditName: () => void;
    onDelete: () => void;
}

export const FormHeader: React.FC<FormHeaderProps> = ({
                                                          currentForm,
                                                          toggleFormVisibility,
                                                          onBackClick,
                                                          onEditName,
                                                          onDelete
                                                      }) => {
    return (
        <div className={'zr-mb-3 zr-py-3'}>
            <div className={'zr-d-flex zr-justify-between'}>
                <div className={cx(styles['zr-sub-contact-wrapper'])}>
                    <div className={'zr-d-flex zr-items-start zr-flex-column zr-gap-2'}>
                        <div className={'zr-d-flex zr-items-center zr-gap-3'}>
                            <h2 className={cx(styles['zr-sub-contact-header'])}>
                                {currentForm.name}
                            </h2>
                            <button
                                onClick={() => currentForm.id && toggleFormVisibility(currentForm.id)}
                                className={cx(
                                    styles['status-badge'],
                                    styles['status-badge-clickable'],
                                    currentForm.active ? styles['active'] : styles['inactive']
                                )}
                                type="button"
                            >
                                {currentForm.active ? 'Aktiv' : 'Inaktiv'}
                            </button>
                        </div>
                        <a
                            className={cx(styles['back-button'])}
                            onClick={onBackClick}
                        >
                            Zurück zur Übersicht
                        </a>
                    </div>
                </div>
                <div className={'zr-d-flex zr-items-center zr-gap-1'}>
                <IconButton
                    icon={faEdit}
                    color="#2f2f2f"
                    title="Formular umbenennen"
                    onClick={onEditName}
                />
                <IconButton
                    icon={faTrashAlt}
                    color="#2f2f2f"
                    title="Formular löschen"
                    onClick={onDelete}
                />
                </div>
            </div>
        </div>
    );
};

